export const buildConfig = {
  chainId: process.env.REACT_APP_CHAIN_ID ?? 1,
  alchemyKey: process.env.REACT_APP_ALCHEMY_KEY,
};
